import React from "react";
import Navbar from "../common/Navbar";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

import logoOf from '../img/OpenFiberLogoWhite.png';
import logoFc from '../img/FiberCopLogoWhite.png';
import logoFibreConnect from '../img/FibreConnect.svg';
import TestLogo from '../img/total_research.png';
import UnidataLogo from '../img/unidatalogo.png';

const Home = () => {

    const navigate = useNavigate();

    return(
        <div style={{height: "92vh"}}>
            <Navbar />
            <div style={{width: '100%', backgroundColor: 'white', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0}}>
                <h1 className="homeTitle" >Scegli da quale database ricercare</h1>
                <div className="homeContainer">
                    <div onClick={() => navigate("/total", {replace: true})} className="homeCard" style={{backgroundColor: "#ff0f64", borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <img src={TestLogo} alt="logofc" style={{width: '90%', height: 'auto'}} loading="lazy"/>
                    </div>
                    <div onClick={() => navigate("/research", {replace: true})} className="homeCard" style={{backgroundColor: "#ff0f64", borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <img src={logoOf} alt="logoof" style={{width: '100%'}} loading="lazy"/>
                    </div>

                    <div onClick={() => navigate("/researchfc", {replace: true})} className="homeCard" style={{backgroundColor: "#ff0f64", borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <img src={logoFc} alt="logofc" style={{width: '90%'}} loading="lazy"/>
                    </div>

                    <div onClick={() => navigate("/fibreconnect", {replace: true})} className="homeCard" style={{backgroundColor: "#ff0f64", borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <img src={logoFibreConnect} alt="logofibre" style={{width: '90%', height: '85%'}} loading="lazy"/>
                    </div>

                    <div onClick={() => navigate("/unidata", {replace: true})} className="homeCard" style={{backgroundColor: "#ff0f64", borderRadius: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                        <img src={UnidataLogo} alt="logounidata" style={{width: '95%', height: 'auto'}} loading="lazy"/>
                    </div>
                </div>
            </div>    
        </div>
    )
}

export default Home;